import React, {Component} from "react"
import {Button, Form, Message, Segment,} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization} from "../utils/localization";
import {connect} from "react-redux";
import axios from 'axios';
import {CustomEmailInput, CustomGrid} from "./custom-common";

import {API_URL} from "../utils/config";

const mapStateToProps = (state, ownProps) => {
    const {user} = state;

    return {
        ...ownProps,
        lang: user.lang,
    }
};

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            error: false,
            formSubmittedOk: false,
            submitError: '',
            login: false,
        };
    }

    submit = async () => {
        const {email, password} = this.state;
        if ( email.length === 0 || password.length === 0 ) {
            this.setState({error: true});
        } else {
            this.setState({loading: true});
            try {
                await axios.post(`${API_URL}/login`, {
                    email: email.trim(),
                    password: password,
                }, {headers: {'Content-Type': 'application/json'}});
                this.setState({formSubmittedOk: true, submitError: '', loading: false});
                alert("You are logged in");
            } catch(e) {
                this.setState({
                    formSubmittedOk: false,
                    submitError: e.response ? e.response.data : e.message,
                    loading: false,
                })
            }
        }
    };

    handleFormChange(name, value) {
        this.setState({
            [name]: value,
            error: false,
            submitError: false,
        });
    }

    render() {
        const localization = getLocalization(this.props.lang);
        const strings = localization.login;
        const {email, password} = localization;
        return (
            <React.Fragment>
                <CustomGrid container stackable columns={3}>
                    <CustomGrid.Column />
                    <CustomGrid.Column textAlign='left'>
                        <Segment>
                            <Form>
                                <Form.Field required>
                                    <CustomEmailInput
                                        label={email}
                                        required
                                        value={this.state.email}
                                        placeholder={""}
                                        onChange={(e, {value}) => {
                                            this.handleFormChange("email", value);
                                        }}
                                    />
                                </Form.Field>

                                <Form.Field required>
                                    <label>{password}</label>
                                    <input placeholder={""} value={this.state.password} onChange={(e) => {
                                        this.handleFormChange("password", e.target.value);
                                    }}/>
                                </Form.Field>

                                {!!this.state.error && <Form.Field><Message negative>Please complete all required fields</Message></Form.Field>}
                                {!!this.state.submitError && <Form.Field><Message negative>{this.state.submitError}</Message></Form.Field>}

                                <Form.Field>
                                    <Button loading={this.state.loading} primary fluid onClick={this.submit}>{strings.login}</Button>
                                </Form.Field>
                            </Form>
                        </Segment>
                    </CustomGrid.Column>
                </CustomGrid>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Login));